import { render, staticRenderFns } from "./Entrada.vue?vue&type=template&id=b0f50702&scoped=true"
import script from "./Entrada.vue?vue&type=script&lang=js"
export * from "./Entrada.vue?vue&type=script&lang=js"
import style0 from "./Entrada.vue?vue&type=style&index=0&id=b0f50702&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f50702",
  null
  
)

export default component.exports